








































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import LoadingIndicator from '@components/LoadingIndicator'
import UnsubmittedOfferCard from '@ui/cards/UnsubmittedOfferCard'

settings =
  name: "SubmitOffersStep"

  vue:
    mixins: [WizardService.step()]
    components: { LoadingIndicator, UnsubmittedOfferCard }

    mounted: ->
      @wizard.fetch('draftOffers')
      @wizard.fetch('activations')

    computed:
      purchaseOrderSet: ->
        po_set = {}
        (@wizard.draftOffers || []).forEach((offer) ->
          po_set[offer.purchase_order_id] ||= []
          po_set[offer.purchase_order_id].push offer
        )
        po_set

    methods:
      purchaseOrderCtxForOffer: (offer) -> offer.ctx.purchase_order || {}

export default VueOptions.vue settings
